import { Button } from 'Button';

import { SimpleModalStyled } from './SimpleModalStyled';
import { SimpleModalTitle } from './SimpleModalTitle';
import { SimpleModalActionsStyled } from './SimpleModalActions.styled';
import { SimpleModalContentStyled } from './SimpleModalContent.styled';
import { SimpleModalProps } from './SimpleModal.types';

export function SimpleModal({
  open,
  onClose = () => {},
  title,
  children,
  confirmButtonProps,
  confirmText,
  cancelButtonProps,
  cancelText,
  tertiaryButtonProps,
  tertiaryText,
  customActions = null,
  hideBackdrop = false,
  maxHeight = true,
  ...rest
}: SimpleModalProps) {
  const handleClose = () => {
    onClose();
  };

  return (
    <SimpleModalStyled
      // the corresponding `id` is hardcoded in SimpleModalTitle
      aria-labelledby="simple-modal-title"
      {...rest}
      hideBackdrop={hideBackdrop}
      maxHeight={maxHeight}
      onClose={handleClose}
      open={open}
    >
      <SimpleModalTitle onClose={handleClose} title={title} />
      <SimpleModalContentStyled dividers>{children}</SimpleModalContentStyled>
      {customActions ? (
        <SimpleModalActionsStyled>{customActions}</SimpleModalActionsStyled>
      ) : (
        <SimpleModalActionsStyled>
          {tertiaryText && (
            <Button color="primary" variant="outlined" {...tertiaryButtonProps}>
              {tertiaryText}
            </Button>
          )}
          {cancelText && (
            <Button color="secondary" variant="contained" {...cancelButtonProps}>
              {cancelText}
            </Button>
          )}
          <Button color="primary" variant="contained" {...confirmButtonProps}>
            {confirmText}
          </Button>
        </SimpleModalActionsStyled>
      )}
    </SimpleModalStyled>
  );
}

export default SimpleModal;
